import script from "./ProjectsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsList.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsList.vue?vue&type=style&index=0&id=642e5d48&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642e5d48"]])

export default __exports__